// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Answers Table Column Widths */
.answers-question-col {
  width: 50%;
  min-width: 250px;
  max-width: 700px;
  word-break: break-word;
}
.answers-attempt-col {
  width: 15%;
  min-width: 80px;
  max-width: 180px;
  white-space: nowrap;
}
/* Notes Table Column Widths */
.notes-user-col {
  width: 100px;
  min-width: 80px;
  max-width: 120px;
  white-space: nowrap;
}
.notes-date-col {
  width: 140px;
  min-width: 100px;
  max-width: 160px;
  white-space: nowrap;
}
.notes-note-col {
  width: 100%;
  min-width: 200px;
  max-width: 1000px;
  word-break: break-word;
}
/* Section Box - Single container per section */
.section-box {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 25px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.section-title {
  color: #2c3e50;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #3498db;
}

/* Form rows */
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -10px;
  margin-left: -10px;
  margin-bottom: 5px;
}

.form-group {
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 18px;
}

  .form-group label {
    font-weight: 600;
    margin-bottom: 5px;
    color: #34495e;
    font-size: 13px;
    display: block;
  }

  .form-group small {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    color: #7f8c8d;
    line-height: 1.3;
  }

/* Form controls */
.form-control {
  height: 36px;
  font-size: 13px;
  border-radius: 4px;
  border: 1px solid #ced4da;
  width: 100%;
}

  .form-control:disabled {
    background-color: #f8f9fa;
    color: #495057;
    cursor: default;
    border-color: #dee2e6;
  }

select.form-control {
  padding-right: 30px;
}

  select.form-control:disabled {
    background-color: #f8f9fa;
    opacity: 1;
  }

textarea.form-control {
  height: auto;
  min-height: 60px;
  resize: vertical;
  width: 905px;
}

/* Tables */
.notes-table,
.answers-table {
  margin-bottom: 0;
  font-size: 13px;
}

  .notes-table th,
  .answers-table th {
    background-color: #f8f9fa;
    font-weight: 600;
    padding: 12px 10px;
    border-bottom: 2px solid #dee2e6;
    color: #2c3e50;
  }

    .notes-table th small,
    .answers-table th small {
      font-weight: normal;
      color: #7f8c8d;
      font-size: 11px;
      display: block;
      margin-top: 3px;
    }

  .notes-table td,
  .answers-table td {
    padding: 10px;
    vertical-align: middle;
    border-color: #e9ecef;
  }

  /* Question responses table inputs */
  .answers-table .form-control {
    height: 32px;
    padding: 4px 8px;
    font-size: 12px;
  }

  .answers-table td {
    padding: 5px !important;
  }

/* Add note section */
.add-note-section {
  border-top: 1px solid #e9ecef;
}

.align-items-end {
  align-items: flex-end !important;
}

.char-count {
  display: block;
  text-align: right;
  font-size: 11px;
  color: #7f8c8d;
  margin-top: 3px;
}

/* Header */
.pgTitleWrap {
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 15px;
  margin-bottom: 20px;
}

  .pgTitleWrap h2 {
    font-size: 22px;
    margin-bottom: 0;
    color: #2c3e50;
    display: flex;
    align-items: center;
    width: 100%;
  }

/* Header buttons */
.header-buttons {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

.saveBtn {
  height: 32px;
  background-color: #28a745;
  border-color: #28a745;
  padding: 0 15px;
  font-size: 13px;
  color: white;
}

  .saveBtn:hover {
    background-color: #218838;
    border-color: #1e7e34;
  }

.exportExcelBtn {
  height: 32px;
  background-color: #fff;
  padding: 0 15px;
  font-size: 13px;
}

  .exportExcelBtn:hover {
    border: 1px solid #3498db !important;
    color: #3498db;
  }

.mr-2 {
  margin-right: 8px;
}

/* Container */
.adminWrap {
  padding: 15px 0;
}

.container-fluid {
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* Button styles */
.btn-primary {
  background-color: #3498db;
  border-color: #3498db;
  font-size: 13px;
  padding: 8px 16px;
  height: 34px !important;
  margin-top: 25px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

  .btn-primary i {
    font-size: 14px;
  }

  .btn-primary:hover {
    background-color: #2980b9;
    border-color: #2980b9;
  }

  .btn-primary:disabled {
    background-color: #95a5a6;
    border-color: #95a5a6;
    cursor: not-allowed;
  }

.btn-small {
  height: 30px !important;
  padding: 6px 14px !important;
  font-size: 13px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  margin-top: 25px !important;
}

.btn-sm {
  padding: 4px 10px;
  font-size: 12px;
}

/* Column widths */
.col-md-2 {
  flex: 0 0 16.666667%;
  max-width: 16.666667%;
}

.col-md-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4 {
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

.col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8 {
  flex: 0 0 66.666667%;
  max-width: 66.666667%;
}

/* Text utilities */
.text-center {
  text-align: center;
}

.text-muted {
  color: #95a5a6;
}

/* Required field asterisk */
.required-field {
  color: #e74c3c;
  margin-left: 2px;
}

/* Responsive */
@media (max-width: 768px) {
  .section-box {
    padding: 15px;
  }

  .form-group {
    margin-bottom: 15px;
  }

  .col-md-2, .col-md-3, .col-md-4, .col-md-6, .col-md-8 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .add-note-section .form-group {
    margin-bottom: 10px;
  }

  .red-asterisk {
    color: #e74c3c;
    margin-left: 2px;
    font-weight: bold;
  }

  .header-buttons {
    flex-direction: column;
    gap: 5px;
  }
  .btn-small {
    padding: 4px 16px;
    font-size: 13px;
    line-height: 1.5;
  }
}

:host ::ng-deep .ui-panel .ui-panel-titlebar,
:host ::ng-deep .p-panel .p-panel-header {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #2c3e50 !important;
  border-bottom: 3px solid #3498db !important;
  padding-bottom: 8px !important;
  background: transparent !important;
}

:host ::ng-deep .section-box {
  margin-bottom: 32px !important; 
}
.participant-name {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  letter-spacing: 0.5px;
}

/* Group Member Selection Dialog */
:host ::ng-deep .group-member-dialog .p-dialog-content {
  padding: 1.5rem;
}

.group-member-dialog-content {
  max-height: 60vh;
  overflow-y: auto;
}

.group-member-dialog-content .table {
  margin-bottom: 0;
  font-size: 13px;
}

.group-member-dialog-content .table thead th {
  background-color: #f8f9fa;
  color: #495057;
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
  padding: 12px 8px;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}

.group-member-dialog-content .table tbody td {
  padding: 10px 8px;
  vertical-align: middle;
  border-bottom: 1px solid #e9ecef;
}

.group-member-dialog-content .table tbody tr:hover {
  background-color: #f1f3f5;
}

.group-member-dialog-content .table tbody tr.selected-row {
  background-color: #cfe2ff;
}

.group-member-dialog-content .table tbody tr.selected-row:hover {
  background-color: #b6d4fe;
}

:host ::ng-deep .group-member-dialog .p-dialog-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #dee2e6;
}

:host ::ng-deep .group-member-dialog .p-dialog-footer .btn {
  margin-left: 0.5rem;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
 `, "",{"version":3,"sources":["webpack://./src/app/admin/admin-participant-answers/admin-participant-answers.component.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;EAEE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;AAEF,kBAAkB;AAClB;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;EAEE;IACE,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,qBAAqB;EACvB;;AAEF;EACE,mBAAmB;AACrB;;EAEE;IACE,yBAAyB;IACzB,UAAU;EACZ;;AAEF;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA,WAAW;AACX;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;EAEE;;IAEE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;EAChB;;IAEE;;MAEE,mBAAmB;MACnB,cAAc;MACd,eAAe;MACf,cAAc;MACd,eAAe;IACjB;;EAEF;;IAEE,aAAa;IACb,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA,oCAAoC;EACpC;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;AAEF,qBAAqB;AACrB;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;EAEE;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;AAEF,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;EAEE;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;AAEF;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;EAEE;IACE,oCAAoC;IACpC,cAAc;EAChB;;AAEF;EACE,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;EACrB;;AAEF;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,2CAA2C;EAC3C,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Answers Table Column Widths */\r\n.answers-question-col {\r\n  width: 50%;\r\n  min-width: 250px;\r\n  max-width: 700px;\r\n  word-break: break-word;\r\n}\r\n.answers-attempt-col {\r\n  width: 15%;\r\n  min-width: 80px;\r\n  max-width: 180px;\r\n  white-space: nowrap;\r\n}\r\n/* Notes Table Column Widths */\r\n.notes-user-col {\r\n  width: 100px;\r\n  min-width: 80px;\r\n  max-width: 120px;\r\n  white-space: nowrap;\r\n}\r\n.notes-date-col {\r\n  width: 140px;\r\n  min-width: 100px;\r\n  max-width: 160px;\r\n  white-space: nowrap;\r\n}\r\n.notes-note-col {\r\n  width: 100%;\r\n  min-width: 200px;\r\n  max-width: 1000px;\r\n  word-break: break-word;\r\n}\r\n/* Section Box - Single container per section */\r\n.section-box {\r\n  background: #ffffff;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  margin-bottom: 25px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.section-title {\r\n  color: #2c3e50;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin-bottom: 20px;\r\n  padding-bottom: 10px;\r\n  border-bottom: 2px solid #3498db;\r\n}\r\n\r\n/* Form rows */\r\n.form-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: -10px;\r\n  margin-left: -10px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.form-group {\r\n  padding-right: 10px;\r\n  padding-left: 10px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n  .form-group label {\r\n    font-weight: 600;\r\n    margin-bottom: 5px;\r\n    color: #34495e;\r\n    font-size: 13px;\r\n    display: block;\r\n  }\r\n\r\n  .form-group small {\r\n    display: block;\r\n    margin-top: 4px;\r\n    font-size: 11px;\r\n    color: #7f8c8d;\r\n    line-height: 1.3;\r\n  }\r\n\r\n/* Form controls */\r\n.form-control {\r\n  height: 36px;\r\n  font-size: 13px;\r\n  border-radius: 4px;\r\n  border: 1px solid #ced4da;\r\n  width: 100%;\r\n}\r\n\r\n  .form-control:disabled {\r\n    background-color: #f8f9fa;\r\n    color: #495057;\r\n    cursor: default;\r\n    border-color: #dee2e6;\r\n  }\r\n\r\nselect.form-control {\r\n  padding-right: 30px;\r\n}\r\n\r\n  select.form-control:disabled {\r\n    background-color: #f8f9fa;\r\n    opacity: 1;\r\n  }\r\n\r\ntextarea.form-control {\r\n  height: auto;\r\n  min-height: 60px;\r\n  resize: vertical;\r\n  width: 905px;\r\n}\r\n\r\n/* Tables */\r\n.notes-table,\r\n.answers-table {\r\n  margin-bottom: 0;\r\n  font-size: 13px;\r\n}\r\n\r\n  .notes-table th,\r\n  .answers-table th {\r\n    background-color: #f8f9fa;\r\n    font-weight: 600;\r\n    padding: 12px 10px;\r\n    border-bottom: 2px solid #dee2e6;\r\n    color: #2c3e50;\r\n  }\r\n\r\n    .notes-table th small,\r\n    .answers-table th small {\r\n      font-weight: normal;\r\n      color: #7f8c8d;\r\n      font-size: 11px;\r\n      display: block;\r\n      margin-top: 3px;\r\n    }\r\n\r\n  .notes-table td,\r\n  .answers-table td {\r\n    padding: 10px;\r\n    vertical-align: middle;\r\n    border-color: #e9ecef;\r\n  }\r\n\r\n  /* Question responses table inputs */\r\n  .answers-table .form-control {\r\n    height: 32px;\r\n    padding: 4px 8px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .answers-table td {\r\n    padding: 5px !important;\r\n  }\r\n\r\n/* Add note section */\r\n.add-note-section {\r\n  border-top: 1px solid #e9ecef;\r\n}\r\n\r\n.align-items-end {\r\n  align-items: flex-end !important;\r\n}\r\n\r\n.char-count {\r\n  display: block;\r\n  text-align: right;\r\n  font-size: 11px;\r\n  color: #7f8c8d;\r\n  margin-top: 3px;\r\n}\r\n\r\n/* Header */\r\n.pgTitleWrap {\r\n  border-bottom: 1px solid #dee2e6;\r\n  padding-bottom: 15px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n  .pgTitleWrap h2 {\r\n    font-size: 22px;\r\n    margin-bottom: 0;\r\n    color: #2c3e50;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n  }\r\n\r\n/* Header buttons */\r\n.header-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-left: auto;\r\n}\r\n\r\n.saveBtn {\r\n  height: 32px;\r\n  background-color: #28a745;\r\n  border-color: #28a745;\r\n  padding: 0 15px;\r\n  font-size: 13px;\r\n  color: white;\r\n}\r\n\r\n  .saveBtn:hover {\r\n    background-color: #218838;\r\n    border-color: #1e7e34;\r\n  }\r\n\r\n.exportExcelBtn {\r\n  height: 32px;\r\n  background-color: #fff;\r\n  padding: 0 15px;\r\n  font-size: 13px;\r\n}\r\n\r\n  .exportExcelBtn:hover {\r\n    border: 1px solid #3498db !important;\r\n    color: #3498db;\r\n  }\r\n\r\n.mr-2 {\r\n  margin-right: 8px;\r\n}\r\n\r\n/* Container */\r\n.adminWrap {\r\n  padding: 15px 0;\r\n}\r\n\r\n.container-fluid {\r\n  background-color: #f5f7fa;\r\n  min-height: 100vh;\r\n}\r\n\r\n/* Button styles */\r\n.btn-primary {\r\n  background-color: #3498db;\r\n  border-color: #3498db;\r\n  font-size: 13px;\r\n  padding: 8px 16px;\r\n  height: 34px !important;\r\n  margin-top: 25px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n  .btn-primary i {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .btn-primary:hover {\r\n    background-color: #2980b9;\r\n    border-color: #2980b9;\r\n  }\r\n\r\n  .btn-primary:disabled {\r\n    background-color: #95a5a6;\r\n    border-color: #95a5a6;\r\n    cursor: not-allowed;\r\n  }\r\n\r\n.btn-small {\r\n  height: 30px !important;\r\n  padding: 6px 14px !important;\r\n  font-size: 13px !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  gap: 6px !important;\r\n  margin-top: 25px !important;\r\n}\r\n\r\n.btn-sm {\r\n  padding: 4px 10px;\r\n  font-size: 12px;\r\n}\r\n\r\n/* Column widths */\r\n.col-md-2 {\r\n  flex: 0 0 16.666667%;\r\n  max-width: 16.666667%;\r\n}\r\n\r\n.col-md-3 {\r\n  flex: 0 0 25%;\r\n  max-width: 25%;\r\n}\r\n\r\n.col-md-4 {\r\n  flex: 0 0 33.333333%;\r\n  max-width: 33.333333%;\r\n}\r\n\r\n.col-md-6 {\r\n  flex: 0 0 50%;\r\n  max-width: 50%;\r\n}\r\n\r\n.col-md-8 {\r\n  flex: 0 0 66.666667%;\r\n  max-width: 66.666667%;\r\n}\r\n\r\n/* Text utilities */\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.text-muted {\r\n  color: #95a5a6;\r\n}\r\n\r\n/* Required field asterisk */\r\n.required-field {\r\n  color: #e74c3c;\r\n  margin-left: 2px;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .section-box {\r\n    padding: 15px;\r\n  }\r\n\r\n  .form-group {\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .col-md-2, .col-md-3, .col-md-4, .col-md-6, .col-md-8 {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .add-note-section .form-group {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .red-asterisk {\r\n    color: #e74c3c;\r\n    margin-left: 2px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .header-buttons {\r\n    flex-direction: column;\r\n    gap: 5px;\r\n  }\r\n  .btn-small {\r\n    padding: 4px 16px;\r\n    font-size: 13px;\r\n    line-height: 1.5;\r\n  }\r\n}\r\n\r\n:host ::ng-deep .ui-panel .ui-panel-titlebar,\r\n:host ::ng-deep .p-panel .p-panel-header {\r\n  font-size: 1.5rem !important;\r\n  font-weight: 700 !important;\r\n  color: #2c3e50 !important;\r\n  border-bottom: 3px solid #3498db !important;\r\n  padding-bottom: 8px !important;\r\n  background: transparent !important;\r\n}\r\n\r\n:host ::ng-deep .section-box {\r\n  margin-bottom: 32px !important; \r\n}\r\n.participant-name {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: #2c3e50;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n/* Group Member Selection Dialog */\r\n:host ::ng-deep .group-member-dialog .p-dialog-content {\r\n  padding: 1.5rem;\r\n}\r\n\r\n.group-member-dialog-content {\r\n  max-height: 60vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.group-member-dialog-content .table {\r\n  margin-bottom: 0;\r\n  font-size: 13px;\r\n}\r\n\r\n.group-member-dialog-content .table thead th {\r\n  background-color: #f8f9fa;\r\n  color: #495057;\r\n  font-weight: 600;\r\n  border-bottom: 2px solid #dee2e6;\r\n  padding: 12px 8px;\r\n  white-space: nowrap;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.group-member-dialog-content .table tbody td {\r\n  padding: 10px 8px;\r\n  vertical-align: middle;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.group-member-dialog-content .table tbody tr:hover {\r\n  background-color: #f1f3f5;\r\n}\r\n\r\n.group-member-dialog-content .table tbody tr.selected-row {\r\n  background-color: #cfe2ff;\r\n}\r\n\r\n.group-member-dialog-content .table tbody tr.selected-row:hover {\r\n  background-color: #b6d4fe;\r\n}\r\n\r\n:host ::ng-deep .group-member-dialog .p-dialog-footer {\r\n  padding: 1rem 1.5rem;\r\n  border-top: 1px solid #dee2e6;\r\n}\r\n\r\n:host ::ng-deep .group-member-dialog .p-dialog-footer .btn {\r\n  margin-left: 0.5rem;\r\n}\r\n\r\ninput[type=\"number\"]::-webkit-outer-spin-button,\r\ninput[type=\"number\"]::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\ninput[type=\"number\"] {\r\n  -moz-appearance: textfield;\r\n}\r\n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
